// extracted by css-extract-rspack-plugin
module.exports =  {"root":"UnreadCount__root___jbqRJ"};